<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6
      slot="header"
      class="modal-title text-success font-weight-bold"
      id="modal-title-default"
    >SOP Sistem Informasi Pajak Daerah</h6>
    <div class="d-block" style="overflow-x: auto;
	white-space: nowrap;">
      <div class="row">
        <div class="col-lg-12 col-sm-12">
          
<table border=0 cellpadding=0 cellspacing=0 width=1130 style='border-collapse:
 collapse;table-layout:fixed;width:849pt'>
 <col class=xl104 width=32 style='mso-width-source:userset;mso-width-alt:1170;
 width:24pt'>
 <col class=xl104 width=196 style='mso-width-source:userset;mso-width-alt:7168;
 width:147pt'>
 <col class=xl104 width=90 style='mso-width-source:userset;mso-width-alt:3291;
 width:68pt'>
 <col class=xl104 width=89 style='mso-width-source:userset;mso-width-alt:3254;
 width:67pt'>
 <col class=xl104 width=102 style='mso-width-source:userset;mso-width-alt:3730;
 width:77pt'>
 <col class=xl104 width=105 style='mso-width-source:userset;mso-width-alt:3840;
 width:79pt'>
 <col class=xl104 width=178 style='mso-width-source:userset;mso-width-alt:6509;
 width:134pt'>
 <col class=xl104 width=83 style='mso-width-source:userset;mso-width-alt:3035;
 width:62pt'>
 <col class=xl104 width=136 style='mso-width-source:userset;mso-width-alt:4973;
 width:102pt'>
 <col class=xl104 width=119 style='mso-width-source:userset;mso-width-alt:4352;
 width:89pt'>
 <col class=xl104 width=14 style='mso-width-source:userset;mso-width-alt:512;
 width:11pt'>
 <tr class=xl104 height=22 style='height:16.5pt'>
  <td height=22 class=xl102 colspan=4 width=407 style='height:16.5pt;
  mso-ignore:colspan;width:306pt'><a name="Print_Area">Prosedur Pelayanan
  Pembayaran Pajak Daerah</a></td>
  <td class=xl103 width=102 style='width:77pt'></td>
  <td class=xl103 width=105 style='width:79pt'></td>
  <td class=xl103 width=178 style='width:134pt'></td>
  <td class=xl103 width=83 style='width:62pt'></td>
  <td class=xl103 width=136 style='width:102pt'></td>
  <td class=xl103 width=119 style='width:89pt'></td>
 </tr>
 <tr height=20 style='height:15.0pt'>
  <td height=20 class=xl104 style='height:15.0pt'></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
 </tr>
 <tr height=28 style='mso-height-source:userset;height:21.0pt'>
  <td rowspan=3 height=128 class=xl314 style='border-bottom:.5pt solid black;
  height:96.0pt'>No</td>
  <td rowspan=3 class=xl107 style='border-bottom:.5pt solid black'>Uraian</td>
  <td colspan=4 class=xl118 style='border-left:none'>Pelaksana</td>
  <td colspan=3 class=xl317 style='border-right:.5pt solid black;border-left:
  none'>Mutu Baku</td>
  <td rowspan=3 class=xl107 style='border-bottom:.5pt solid black'>Ket</td>
 </tr>
 <tr height=20 style='mso-height-source:userset;height:15.0pt'>
  <td rowspan=2 height=100 class=xl306 width=90 style='border-bottom:.5pt solid black;
  height:75.0pt;border-top:none;width:68pt'>Bidang Pembukuan dan Pelaporan</td>
  <td rowspan=2 class=xl308 width=89 style='border-bottom:.5pt solid black;
  width:67pt'>Kas Daerah</td>
  <td rowspan=2 class=xl308 width=102 style='border-bottom:.5pt solid black;
  width:77pt'>Bendahara Penerimaan</td>
  <td rowspan=2 class=xl305 style='border-bottom:.5pt solid black'>Wajib Pajak</td>
  <td rowspan=2 class=xl107 style='border-bottom:.5pt solid black;border-top:
  none'>Persyaratan/Kelengkapan</td>
  <td rowspan=2 class=xl107 style='border-bottom:.5pt solid black;border-top:
  none'>Waktu</td>
  <td rowspan=2 class=xl309 style='border-bottom:.5pt solid black;border-top:
  none'>Output</td>
 </tr>
 <tr height=80 style='mso-height-source:userset;height:60.0pt'>
 </tr>
 <tr height=162 style='mso-height-source:userset;height:121.5pt'>
  <td height=162 class=xl107 style='height:121.5pt;border-top:none'>1</td>
  <td class=xl105 width=196 style='border-top:none;border-left:none;width:147pt'>Wajib
  Pajak melaksanakan pembayaran dengan menyerahkan menyerahkan berkas STPD atau
  surat ketetapan.</td>
  <td align=left valign=top><!--[if gte vml 1]><v:shapetype id="_x0000_t75"
   coordsize="21600,21600" o:spt="75" o:preferrelative="t" path="m@4@5l@4@11@9@11@9@5xe"
   filled="f" stroked="f">
   <v:stroke joinstyle="miter"/>
   <v:formulas>
    <v:f eqn="if lineDrawn pixelLineWidth 0"/>
    <v:f eqn="sum @0 1 0"/>
    <v:f eqn="sum 0 0 @1"/>
    <v:f eqn="prod @2 1 2"/>
    <v:f eqn="prod @3 21600 pixelWidth"/>
    <v:f eqn="prod @3 21600 pixelHeight"/>
    <v:f eqn="sum @0 0 1"/>
    <v:f eqn="prod @6 1 2"/>
    <v:f eqn="prod @7 21600 pixelWidth"/>
    <v:f eqn="sum @8 21600 0"/>
    <v:f eqn="prod @7 21600 pixelHeight"/>
    <v:f eqn="sum @10 21600 0"/>
   </v:formulas>
   <v:path o:extrusionok="f" gradientshapeok="t" o:connecttype="rect"/>
   <o:lock v:ext="edit" aspectratio="t"/>
  </v:shapetype><v:shape id="Rounded_x0020_Rectangle_x0020_35" o:spid="_x0000_s6145"
   type="#_x0000_t75" style='position:absolute;margin-left:225pt;margin-top:30pt;
   width:52.5pt;height:25.5pt;z-index:1;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image031.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Multidocument_x0020_40" o:spid="_x0000_s6146"
   type="#_x0000_t75" style='position:absolute;margin-left:74.25pt;
   margin-top:156pt;width:55.5pt;height:39pt;z-index:2;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image076.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Punched_x0020_Tape_x0020_41"
   o:spid="_x0000_s6147" type="#_x0000_t75" style='position:absolute;
   margin-left:74.25pt;margin-top:193.5pt;width:23.25pt;height:27pt;z-index:3;
   visibility:visible;mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH
74LvEOYqbaoHEWm6B6tHFV0fYEimbdg2CZlYd9/edD8u4goeZ+b/8SOpV9tpFDNFtt4puC4rEOS0
N9b1Cj7WT8UdCE7oDI7ekYIdMayay4t6vQvEIrsdKxhSCvdSsh5oQi59IJcvnY8TpjzGXgbUG+xJ
3lTVrdTeJXKpSEsGNHVLHX6OSTxu8/pAEmlkEA8H4dKlAEMYrcaUSeXszI+W4thQZudew4MNfJUx
QP7asFzOFxx9L/lpojUkXjGmZ5wyhjSRJQ8YKGvKv1MWzIkL33VWU9lGfl98J6hz4cZ/uUjzf7Pb
bHuj+ZQu9z/UfAMAAP//AwBQSwMEFAAGAAgAAAAhADHdX2HSAAAAjwEAAAsAAABfcmVscy8ucmVs
c6SQwWrDMAyG74O9g9G9cdpDGaNOb4VeSwe7CltJTGPLWCZt376mMFhGbzvqF/o+8e/2tzCpmbJ4
jgbWTQuKomXn42Dg63xYfYCSgtHhxJEM3Elg372/7U40YalHMvokqlKiGBhLSZ9aix0poDScKNZN
zzlgqWMedEJ7wYH0pm23Ov9mQLdgqqMzkI9uA+p8T9X8hx28zSzcl8Zy0Nz33r6iasfXeKK5UjAP
VAy4LM8w09zU50C/9q7/6ZURE31X/kL8TKv1x6wXNXYPAAAA//8DAFBLAwQUAAYACAAAACEAoN3a
5GADAADECQAAEAAAAGRycy9zaGFwZXhtbC54bWzsVttu2zgQfS+w/0DwvbWuTixELlK3Lgp0s0aS
fsBYoiyiFMmSjC/9+g5JxXG7WWC3bt/WBmRehmdmzhkNffV6PwiyZcZyJWuavkooYbJRLZebmn66
X768pMQ6kC0IJVlND8zS1/M/XlztW1OBbHplCEJIW+FCTXvndDWZ2KZnA9hXSjOJu50yAzicms2k
NbBD8EFMsiSZTqw2DFrbM+bexh06D9hupxZMiOvgIi51Rg1x1Cgxz68mPgY/DAdw8FfXzWdlVsyO
W34l7Bq1m0/jsh8+roUTRTpLy+NeOBKgn/w5dfTxT37zi7S4KP6T4zTLy1mWPOP50Z/VZIDGqJpS
4tjeCS4/4zgGI7d3emXGwG62K0N4W9Mio0TCgFIthdo1PRhXkdUD0shacg+akSKlk+OpCAGV1R9V
89mOWsJPKDkAl+haLXqQG3ZtkObeS4tV5f1FsW7GmMPsNAGLqZD17k/VYuTw4BQmCdW+M8O5IXkc
1XVkX9M8zbLkEgk6IE9pMs3zzIcGFVJLGjTILqZZVlLSoEE2K5KkDKHHQLyhNta9Z+rsoIgHqmmH
EiFfxo0CeX1C4rD9aJ1n7cmld2+V4O2SC/ErSLFms14IQ7YgsFjCZ8z26Mb7FPJcZ2RXU3wty5DZ
d9jfhZCEz3MhDNwxQwQfanp5NILKl9c72QYFHXARx0iZkGO9+aqKpe72b1R78Pms8RdrLTatny90
o1A/7JbYO3GAbfArJTsDuqb2ywMYRon4ILH4Z2lRoJkLk6K8yHBiTnfWpzuxo9bUURKHC4ddFY88
aMM3PXpKA4tSXeM70vGxRmJOQS3r7txBsHPzC6Tqc1F8REECr8mdbvzc6mbVuFh1aVqinqPkpxbX
nXu0dXa0fbJEiGDg3w4vMFTxgbIKbD41ZfLlpzu8uL7WdIr43oJ1HWtcfKswGnBcEnfQrIMGO84C
BF8bTokGqSwuJFmyTEp8+m+R5P6Ju9w1/RIGLrBB5Ljg+6tloRJiI4ET0Hs+MEtu2I7cqgGwOZ6A
Z8kUQUuE9k7yv4GneO/+CN7Y3waOTJrIpJvfat92kH+/GKiT7QoM3D5Hb5r+z++/EA+pZEcWY1sf
W9RjYwo3otXjxSw4k+4tOPB3gP+b88PfobAWO8T8GwAAAP//AwBQSwMEFAAGAAgAAAAhAP0x8Fge
AQAAnAEAAA8AAABkcnMvZG93bnJldi54bWx8UF1Lw0AQfBf8D8cKvoi9JG3aWnstRRRFQUjV9zXZ
9IK5u3J3tqm/3q0fFHzwcWZ3Zmd2Ou9MKzbkQ+OsgrSXgCBbuqqxKwXPTzfnYxAhoq2wdZYU7CjA
fHZ8NMVJ5ba2oM0yrgSb2DBBBTrG9UTKUGoyGHpuTZZntfMGI0O/kpXHLZubVmZJMpQGG8sXNK7p
SlP5tnw3CnzeneHDso3XWZEgvoy0v19opU5PusUliEhdPCz/qO8qBYMMRH27e/VNVWCI5BVwH27H
zWDGkbt2YUvtvKgLCs0H9/nma++M8G6rYAiidK2CPuzxY10Higou0sEgYSse/VLjfJTlIPeu0f2n
TbN81P8j7o/ThClWy0OoL3B46uwTAAD//wMAUEsBAi0AFAAGAAgAAAAhAPD3irv9AAAA4gEAABMA
AAAAAAAAAAAAAAAAAAAAAFtDb250ZW50X1R5cGVzXS54bWxQSwECLQAUAAYACAAAACEAMd1fYdIA
AACPAQAACwAAAAAAAAAAAAAAAAAuAQAAX3JlbHMvLnJlbHNQSwECLQAUAAYACAAAACEAoN3a5GAD
AADECQAAEAAAAAAAAAAAAAAAAAApAgAAZHJzL3NoYXBleG1sLnhtbFBLAQItABQABgAIAAAAIQD9
MfBYHgEAAJwBAAAPAAAAAAAAAAAAAAAAALcFAABkcnMvZG93bnJldi54bWxQSwUGAAAAAAQABAD1
AAAAAgcAAAAA
" o:insetmode="auto">
   <v:imagedata src="image077.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_2" o:spid="_x0000_s6148"
   type="#_x0000_t75" style='position:absolute;margin-left:123pt;margin-top:53.25pt;
   width:128.25pt;height:129pt;z-index:4;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image078.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Document_x0020_6" o:spid="_x0000_s6149"
   type="#_x0000_t75" style='position:absolute;margin-left:234.75pt;
   margin-top:262.5pt;width:39.75pt;height:28.5pt;z-index:5;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image079.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Document_x0020_7" o:spid="_x0000_s6150"
   type="#_x0000_t75" style='position:absolute;margin-left:228pt;margin-top:280.5pt;
   width:39pt;height:28.5pt;z-index:6;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH
74LvEOYqbaoHEWm6B6tHFV0fYEimbdg2CZlYd9/edD8u4goeZ+b/8SOpV9tpFDNFtt4puC4rEOS0
N9b1Cj7WT8UdCE7oDI7ekYIdMayay4t6vQvEIrsdKxhSCvdSsh5oQi59IJcvnY8TpjzGXgbUG+xJ
3lTVrdTeJXKpSEsGNHVLHX6OSTxu8/pAEmlkEA8H4dKlAEMYrcaUSeXszI+W4thQZudew4MNfJUx
QP7asFzOFxx9L/lpojUkXjGmZ5wyhjSRJQ8YKGvKv1MWzIkL33VWU9lGfl98J6hz4cZ/uUjzf7Pb
bHuj+ZQu9z/UfAMAAP//AwBQSwMEFAAGAAgAAAAhADHdX2HSAAAAjwEAAAsAAABfcmVscy8ucmVs
c6SQwWrDMAyG74O9g9G9cdpDGaNOb4VeSwe7CltJTGPLWCZt376mMFhGbzvqF/o+8e/2tzCpmbJ4
jgbWTQuKomXn42Dg63xYfYCSgtHhxJEM3Elg372/7U40YalHMvokqlKiGBhLSZ9aix0poDScKNZN
zzlgqWMedEJ7wYH0pm23Ov9mQLdgqqMzkI9uA+p8T9X8hx28zSzcl8Zy0Nz33r6iasfXeKK5UjAP
VAy4LM8w09zU50C/9q7/6ZURE31X/kL8TKv1x6wXNXYPAAAA//8DAFBLAwQUAAYACAAAACEAsBjg
MFwDAAC8CQAAEAAAAGRycy9zaGFwZXhtbC54bWzsVtuO2zgMfV9g/0HQexvbsXMxximmmc1igXY6
aKYfwMhyLFSWXEmTS7++lORk0m4XaJvdt/UAHoqkSIqHPsrNq0MnyY4bK7SqaPoyoYQrpmuhthX9
8Lh6MaPEOlA1SK14RY/c0leL33+7OdSmBMVabQiGULZERUVb5/pyNLKs5R3Yl7rnCq2NNh04XJrt
qDawx+CdHGVJMhnZ3nCobcu5u4sWugix3V4vuZS3IUVUNUZ3UWJaLoqbka/Bi2EDCu+aZpHhM56f
bV4VzEbvF9Oo9uJJ5+35bJxlwxa0hS0h9nNCp89J/inxNJklaf5TiWfjYlIMW75KfEpne9IBM7qi
lDh+cFKojyjHWtRu3T+Yoa773YMhoq4o4qWgQ6RWUu9ZC8aV5E6zp44rR6Z0dPaPm6G0/RvNPtoB
RfgFDDsQCrPqZQtqy28NHqX1oOI8+XwRpvuh2rC6LN3iIchm/1bXWDQ8OY3Hg/LQmO7aknwc3TTk
UNEimczzZELJEeV0ns3SzJcGJTaVMHTIZ8V0WlDC0GFcZHlWhNJjId6xN9b9yfXVRREfqKINooP9
Mu6ETTg17N5Y51v2nM/ntlqKeiWk/Dc6Ys12s5SG7EDikIRnOOo5jc8p1bXJyL6i8wIb+dURwuKy
hCQ83yuhE44bIkWHU312gtLP1h+qDvA5EDLK2DKphmHzIxXn3B1e6/roc27wPw5a5Kpfn3KjETwk
SaRMFJD9PlOyN9BX1H56AsMpkX8pnPx5mufo5sIiL6YZLsylZXNpiURaUUdJFJcOyRS3PPVGbFvM
lIYuKn2LH0gjhhmJZwpoWbd2R8mvPV9oan9tFF9RgMBjsu5ZwLxnD8zFqUvTAvEcIL/0uG3cydfZ
wffZ0/YsOPivwwMMZXwhrBKZp6Jcvfiwxvvqc0UnGN978KbhzMWvCqsBJxRxx543wJBuliDFxghK
elDaoiLJklVS4Nv/5cnYv9EqHGtX0Anp2QEVnlctD5MQWQQugj6Kjltyz/fkve4AmfEieJZMMGiB
oX2S8d+Cp0jf3wZn9j8Ljp00sZNusX5ce95BALw29E7VD2Dg/ff6m6b/N/gH0MNW8nMXI68PHHVi
pnAf2n64lqXAa/oOHPhLwP+8+eZnUNBFilh8AQAA//8DAFBLAwQUAAYACAAAACEA/JMs8CIBAACb
AQAADwAAAGRycy9kb3ducmV2LnhtbHyQ3UvDMBTF3wX/h3AFX8Sl3dq1q03H8GuCIGxT8DG26Qdr
kpHEtvOv944pwxcfz733nJxf0vkgW9IJYxutGPgjD4hQuS4aVTF43Txcx0Cs46rgrVaCwV5YmGfn
ZylPCt2rlejWriIYomzCGdTO7RJKbV4Lye1I74TCXamN5A6lqWhheI/hsqVjz5tSyRuFL9R8J25r
kW/Xn5JB74dx9/bY3W+u3pfb2bOn74IgYOzyYljcAHFicKfjH/dTwQC7lsv9h2mKFbdOGAaIg3AI
Bhk2HtqFymttSLkStvlCnOO8NFoSo3sGEZBctwxCOOiXsrTCMQii6TjEKFz9jsb+zItCoIdYp/8z
x5MYSf+YIz+YHM30VCpLUZz+NPsGAAD//wMAUEsBAi0AFAAGAAgAAAAhAPD3irv9AAAA4gEAABMA
AAAAAAAAAAAAAAAAAAAAAFtDb250ZW50X1R5cGVzXS54bWxQSwECLQAUAAYACAAAACEAMd1fYdIA
AACPAQAACwAAAAAAAAAAAAAAAAAuAQAAX3JlbHMvLnJlbHNQSwECLQAUAAYACAAAACEAsBjgMFwD
AAC8CQAAEAAAAAAAAAAAAAAAAAApAgAAZHJzL3NoYXBleG1sLnhtbFBLAQItABQABgAIAAAAIQD8
kyzwIgEAAJsBAAAPAAAAAAAAAAAAAAAAALMFAABkcnMvZG93bnJldi54bWxQSwUGAAAAAAQABAD1
AAAAAgcAAAAA
" o:insetmode="auto">
   <v:imagedata src="image080.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_8" o:spid="_x0000_s6151"
   type="#_x0000_t75" style='position:absolute;margin-left:80.25pt;
   margin-top:216.75pt;width:12.75pt;height:68.25pt;z-index:7;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image081.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Multidocument_x0020_12" o:spid="_x0000_s6152"
   type="#_x0000_t75" style='position:absolute;margin-left:75pt;margin-top:279pt;
   width:48pt;height:33pt;z-index:8;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image082.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Document_x0020_13" o:spid="_x0000_s6153"
   type="#_x0000_t75" style='position:absolute;margin-left:72.75pt;
   margin-top:297.75pt;width:39.75pt;height:28.5pt;z-index:9;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image083.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_10" o:spid="_x0000_s6154"
   type="#_x0000_t75" style='position:absolute;margin-left:123pt;margin-top:289.5pt;
   width:108pt;height:12.75pt;z-index:10;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image084.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_16" o:spid="_x0000_s6155" type="#_x0000_t75"
   style='position:absolute;margin-left:140.25pt;margin-top:411.75pt;width:63pt;
   height:18.75pt;z-index:11;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image085.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Document_x0020_17" o:spid="_x0000_s6156"
   type="#_x0000_t75" style='position:absolute;margin-left:133.5pt;
   margin-top:524.25pt;width:40.5pt;height:40.5pt;z-index:12;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image086.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Document_x0020_18" o:spid="_x0000_s6157"
   type="#_x0000_t75" style='position:absolute;margin-left:179.25pt;
   margin-top:524.25pt;width:38.25pt;height:29.25pt;z-index:13;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image087.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Document_x0020_19" o:spid="_x0000_s6158"
   type="#_x0000_t75" style='position:absolute;margin-left:145.5pt;
   margin-top:768.75pt;width:57.75pt;height:33.75pt;z-index:14;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image088.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Document_x0020_20" o:spid="_x0000_s6159"
   type="#_x0000_t75" style='position:absolute;margin-left:138.75pt;
   margin-top:654pt;width:70.5pt;height:25.5pt;z-index:15;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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==
" o:insetmode="auto">
   <v:imagedata src="image089.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Flowchart_x003a__x0020_Terminator_x0020_30" o:spid="_x0000_s6160"
   type="#_x0000_t75" style='position:absolute;margin-left:15pt;margin-top:771.75pt;
   width:37.5pt;height:24pt;z-index:16;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image090.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_31" o:spid="_x0000_s6161"
   type="#_x0000_t75" style='position:absolute;margin-left:92.25pt;
   margin-top:324pt;width:86.25pt;height:94.5pt;z-index:17;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image091.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_33" o:spid="_x0000_s6162"
   type="#_x0000_t75" style='position:absolute;margin-left:171.75pt;
   margin-top:429.75pt;width:33pt;height:101.25pt;z-index:18;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH
7ya+A+FqWqoHY0zpHqwe1Zj1AQhMW2I7EAbr7ts73e5ejGviEeb/8RuoN7tpFDMk8gG1vC4rKQBt
cB57Ld+3T8WdFJQNOjMGBC33QHLTXF7U230EEuxG0nLIOd4rRXaAyVAZIiBPupAmk/mYehWN/TA9
qJuqulU2YAbMRV4yZFO30JnPMYvHHV+vJAlGkuJhFS5dWpoYR29NZlI1o/vRUhwbSnYeNDT4SFeM
IdWvDcvkfMHR98JPk7wD8WpSfjYTYyiXaNkAweaQWFf+nbSgTlSErvMWyjYRL7V6T3DnSlz4wgTz
f/Nbtr3BfEpXh59qvgEAAP//AwBQSwMEFAAGAAgAAAAhAJYFM1jUAAAAlwEAAAsAAABfcmVscy8u
cmVsc6SQPWsDMQyG90L/g9He8yVDKSW+bIWsIYWuxtZ9kLNkJHNN/n1MoaVXsnWUXvQ8L9rtL2k2
C4pOTA42TQsGKXCcaHDwfnp7egGjxVP0MxM6uKLCvnt82B1x9qUe6ThlNZVC6mAsJb9aq2HE5LXh
jFSTniX5UkcZbPbh7Ae027Z9tvKbAd2KaQ7RgRziFszpmqv5DztNQVi5L03gZLnvp3CPaiN/0hGX
SvEyYHEQRb+WgktTy4G979380xuYCENh+aiOlfwnqfbvBnb1zu4GAAD//wMAUEsDBBQABgAIAAAA
IQAV3x46PAIAAKgGAAAUAAAAZHJzL2Nvbm5lY3RvcnhtbC54bWy8lc2O2yAQx++V+g6Ie9ef8Zdi
r6rstj1U21W7fQDWhsQqBgtQ4rx9B3AcdbXbQxPVF+MZmN/M/AGvb6eBoz1VupeixtFNiBEVrex6
sa3xz6dPHwqMtCGiI1wKWuMj1fi2ef9uPXWqIqLdSYUghNAVGGq8M2asgkC3OzoQfSNHKsDLpBqI
gU+1DTpFDhB84EEchlmgR0VJp3eUmjvvwY2LbQ5yQzn/6BDexJQc/KiVvEnXgc3BDt0CGHxjrEnz
PA7jxWdNzq3koSm82Q5PNusv4iLLV4vPLXGxz0AjF8hb4CJK4yJ6HVwuwf8Ap2VUpvMSSOoMXnCT
+DGigbRK1nhujNhvrPVRzRk97B8V6rsaJylGggwg0j1/lge0kULQ1oBASYKDZfaymlTawMcsH/kH
8QbSC+zYUW7fU41jSyIVFd3VQpdz6NCG9po/nHvgDC96ol13SDUxNVxcnpIGDkYGuxUejBjvxy9g
ADVIJRlDUHQCOsYryPNY43wVRVnpGg5tmAxqYUIUh1kSZRi1MCNJ8jAvXTE+RRtpVNp8pvLydG2g
Gj9TYRb9E5cr2X/VxnbwDLNgfvEGsFEM6fm96JA5jrD/jOqJ2HI618jFrJvXxZ5abY6cevx3Cj10
N8glW9A22ZXprh664QrtCa9x9ytasgCSRbKe86tBw79DZ5bFUsbgNP4v8EJzFUtxPfDQC6leq9pM
p1Yzzzup7rX2J9deXfNVxHvYpHfEkNOxfnHluwX+F9P8BgAA//8DAFBLAwQUAAYACAAAACEAEgl9
lhkBAACKAQAADwAAAGRycy9kb3ducmV2LnhtbGyQSU/DMBCF70j8B2uQuCDqNM3SljpVxCKBhJC6
XLhZibOosR3Zpgn99UwJVS4c3xt/z/Nmte5lQ47C2ForBtOJB0SoTOe1Khnsdy/3cyDWcZXzRivB
4FtYWCfXVyu+zHWnNuK4dSXBEGWXnEHlXLuk1GaVkNxOdCsUzgptJHcoTUlzwzsMlw31PS+iktcK
f6h4Kx4rkR22X5LBu87f1J15Vv3n4rRPD7syKJ5Sxm5v+vQBiBO9Gx//0a85g1kA5y7YAxJcsG9S
lVXakGIjbH3C7Qe/MFoSozsGWC7TDQPkUH8UhRUOXX8exeHv6GIFceSHHtBzrNMDvPgXDuNp6OEV
MfcCzxfhbIDpuFSyQjGeMPkBAAD//wMAUEsBAi0AFAAGAAgAAAAhAP4l66UAAQAA6gEAABMAAAAA
AAAAAAAAAAAAAAAAAFtDb250ZW50X1R5cGVzXS54bWxQSwECLQAUAAYACAAAACEAlgUzWNQAAACX
AQAACwAAAAAAAAAAAAAAAAAxAQAAX3JlbHMvLnJlbHNQSwECLQAUAAYACAAAACEAFd8eOjwCAACo
BgAAFAAAAAAAAAAAAAAAAAAuAgAAZHJzL2Nvbm5lY3RvcnhtbC54bWxQSwECLQAUAAYACAAAACEA
Egl9lhkBAACKAQAADwAAAAAAAAAAAAAAAACcBAAAZHJzL2Rvd25yZXYueG1sUEsFBgAAAAAEAAQA
+QAAAOIFAAAAAA==
">
   <v:imagedata src="image092.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_38" o:spid="_x0000_s6163"
   type="#_x0000_t75" style='position:absolute;margin-left:147.75pt;
   margin-top:477.75pt;width:25.5pt;height:53.25pt;z-index:19;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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=
">
   <v:imagedata src="image093.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_42" o:spid="_x0000_s6164"
   type="#_x0000_t75" style='position:absolute;margin-left:168pt;margin-top:550.5pt;
   width:30.75pt;height:111pt;z-index:20;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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=
">
   <v:imagedata src="image094.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_44" o:spid="_x0000_s6165"
   type="#_x0000_t75" style='position:absolute;margin-left:153.75pt;
   margin-top:561.75pt;width:22.5pt;height:42pt;z-index:21;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image095.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_46" o:spid="_x0000_s6166"
   type="#_x0000_t75" style='position:absolute;margin-left:168pt;margin-top:678pt;
   width:12.75pt;height:95.25pt;z-index:22;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image096.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_48" o:spid="_x0000_s6167"
   type="#_x0000_t75" style='position:absolute;margin-left:51pt;margin-top:779.25pt;
   width:96pt;height:12.75pt;z-index:23;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image097.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><![endif]--><span style='mso-ignore:vglayout;
  position:absolute;z-index:1;margin-left:20px;margin-top:40px;width:350px;
  height:1030px'><img width=350 height=1030 src=/img/image098.png v:shapes="Rounded_x0020_Rectangle_x0020_35 Flowchart_x003a__x0020_Multidocument_x0020_40 Flowchart_x003a__x0020_Punched_x0020_Tape_x0020_41 Elbow_x0020_Connector_x0020_2 Flowchart_x003a__x0020_Document_x0020_6 Flowchart_x003a__x0020_Document_x0020_7 Straight_x0020_Arrow_x0020_Connector_x0020_8 Flowchart_x003a__x0020_Multidocument_x0020_12 Flowchart_x003a__x0020_Document_x0020_13 Straight_x0020_Arrow_x0020_Connector_x0020_10 Rectangle_x0020_16 Flowchart_x003a__x0020_Document_x0020_17 Flowchart_x003a__x0020_Document_x0020_18 Flowchart_x003a__x0020_Document_x0020_19 Flowchart_x003a__x0020_Document_x0020_20 Flowchart_x003a__x0020_Terminator_x0020_30 Elbow_x0020_Connector_x0020_31 Elbow_x0020_Connector_x0020_33 Elbow_x0020_Connector_x0020_38 Elbow_x0020_Connector_x0020_42 Elbow_x0020_Connector_x0020_44 Straight_x0020_Arrow_x0020_Connector_x0020_46 Straight_x0020_Arrow_x0020_Connector_x0020_48"></span><span
  style='mso-ignore:vglayout2'>
  <table cellpadding=0 cellspacing=0>
   <tr>
    <td height=162 class=xl106 width=90 style='height:121.5pt;border-top:none;
    border-left:none;width:68pt'>&nbsp;</td>
   </tr>
  </table>
  </span></td>
  <td class=xl106 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl145 width=178 style='border-top:none;border-left:none;width:134pt'>STPD
  atau surat ketetapan</td>
  <td class=xl108 style='border-top:none;border-left:none'>Seketika</td>
  <td class=xl109 width=136 style='border-top:none;border-left:none;width:102pt'>&nbsp;</td>
  <td class=xl110 width=119 style='border-top:none;border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=162 style='mso-height-source:userset;height:121.5pt'>
  <td height=162 class=xl107 style='height:121.5pt'>2</td>
  <td class=xl105 width=196 style='border-left:none;width:147pt'>Teller Bank
  Kalbar melaksanakan verifikasi dan menerima pembayaran pajak oleh wajib
  pajak.</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl145 width=178 style='border-left:none;width:134pt'>STPD atau
  surat ketetapan</td>
  <td class=xl108 style='border-left:none'>3 Menit</td>
  <td class=xl145 width=136 style='border-left:none;width:102pt'>SSPD atau STS</td>
  <td class=xl110 width=119 style='border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=162 style='mso-height-source:userset;height:121.5pt'>
  <td height=162 class=xl107 style='height:121.5pt'>3</td>
  <td class=xl105 width=196 style='border-left:none;width:147pt'>Jika
  pembayaran pajak oleh wajib pajak bernilai sama dengan nilai pajak terutang
  di dalam STPD atau surat ketetapan, maka teller bank menerbitkan SSPD atau
  STS.</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl145 width=178 style='border-left:none;width:134pt'>&nbsp;</td>
  <td class=xl108 style='border-left:none'>Seketika</td>
  <td class=xl145 width=136 style='border-left:none;width:102pt'>SSPD atau STS</td>
  <td class=xl110 width=119 style='border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=162 style='mso-height-source:userset;height:121.5pt'>
  <td height=162 class=xl107 style='height:121.5pt'>4</td>
  <td class=xl105 width=196 style='border-left:none;width:147pt'>Salinan SSPD
  atau STS diserahkan ke Bendahara Penerimaan untuk dilakukan pencatata.</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl146 width=178 style='border-left:none;width:134pt'>SSPD atau STS</td>
  <td class=xl108 style='border-left:none'>Seketika</td>
  <td class=xl109 width=136 style='border-left:none;width:102pt'>&nbsp;</td>
  <td class=xl110 width=119 style='border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=162 style='mso-height-source:userset;height:121.5pt'>
  <td height=162 class=xl107 style='height:121.5pt'>5</td>
  <td class=xl105 width=196 style='border-left:none;width:147pt'>Bendahara
  Penerimaan mencatat SSPD atau STS ke dalam register dan Buku Pembantu
  Penerimaan Sejenis.</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl146 width=178 style='border-left:none;width:134pt'>SSPD atau STS</td>
  <td class=xl108 style='border-left:none'>60 Menit</td>
  <td class=xl145 width=136 style='border-left:none;width:102pt'>Register
  SSPD/STS dan Buku Pembantu Penerimaan Sejenis.</td>
  <td class=xl110 width=119 style='border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=162 style='mso-height-source:userset;height:121.5pt'>
  <td height=162 class=xl107 style='height:121.5pt'>6</td>
  <td class=xl105 width=196 style='border-left:none;width:147pt'>Berdasarkan
  data register dan BPPS, Bendahara Penerimaan melaksanakan pencatatan di dalam
  Buku Kas Umum.</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-left:none'>&nbsp;</td>
  <td class=xl145 width=178 style='border-left:none;width:134pt'>Register
  SSPD/STS dan Buku Pembantu Penerimaan Sejenis.</td>
  <td class=xl108 style='border-left:none'>30 Menit</td>
  <td class=xl145 width=136 style='border-left:none;width:102pt'>Buku Kas Umum</td>
  <td class=xl110 width=119 style='border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=162 style='mso-height-source:userset;height:121.5pt'>
  <td height=162 class=xl118 style='height:121.5pt'>7</td>
  <td class=xl121 width=196 style='border-left:none;width:147pt'>Bendahara
  Penerimaan menyusun laporan realisasi penerimaan dan menyerahkan laporan
  tersebut ke Bidang Pembukuan dan Pelaporan.</td>
  <td class=xl117 style='border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-left:none'>&nbsp;</td>
  <td class=xl147 width=178 style='border-left:none;width:134pt'>Buku Kas Umum</td>
  <td class=xl148 style='border-left:none'>30 Menit</td>
  <td class=xl147 width=136 style='border-left:none;width:102pt'>Laporan
  Realisasi Penerimaan Kas</td>
  <td class=xl149 width=119 style='border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=0 style='display:none'>
  <td width=32 style='width:24pt'></td>
  <td width=196 style='width:147pt'></td>
  <td width=90 style='width:68pt'></td>
  <td width=89 style='width:67pt'></td>
  <td width=102 style='width:77pt'></td>
  <td width=105 style='width:79pt'></td>
  <td width=178 style='width:134pt'></td>
  <td width=83 style='width:62pt'></td>
  <td width=136 style='width:102pt'></td>
  <td width=119 style='width:89pt'></td>
 </tr>
</table>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    Modal,
    PulseLoader,
  },
  data() {
    return {
      modals: {
        modal1: false,
      },
      htmls: null,
      isBusy: false,
    };
  },
  methods: {
    showModal() {
      this.modals.modal1 = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 1000px;
  margin: 1.75rem auto;
}

</style>